exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* Short media */\n.modal-vacancy-confirm__confirm {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n.modal-vacancy-confirm__confirm .def-button {\n  margin-top: 20px;\n  font-size: 14px;\n}", ""]);

// exports
